import { Header } from "@components/layouts/Header";
import { Footer } from "@components/layouts/Footer";
import { Sidebar } from "@components/layouts/Sidebar";
import { useIsMobile } from "@hooks/useIsMobile";
import { cn } from "@lib/utils";
import { ReactNode } from "react";

interface MainLayoutProps {
  children: ReactNode;
  title?: string;
}

export function MainLayout({ children, title }: MainLayoutProps) {
  const isMobile = useIsMobile();

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Sidebar />
      <Header lastUpdated={null} onRefresh={() => {}} isLoading={false} />
      <div className="flex flex-1">
        <div className={isMobile ? "hidden" : "w-64 flex-shrink-0"} />
        <main
          className={cn(
            "flex-1 transition-all duration-200 w-full overflow-hidden",
            isMobile ? "p-4" : "p-6"
          )}
        >
          <div className="w-full mx-auto p-0">{children}</div>
        </main>
      </div>
      <div
        className={cn(
          "transition-all duration-200",
          isMobile ? "ml-0" : "ml-64"
        )}
      >
        <Footer />
      </div>
    </div>
  );
}
